import React from "react";

export const footerHeight = "0em";

// ! Footer component

export default function Footer() {
  return <></>;
}
